<template>
    <i v-if="level" :class="['k-badge-level', `badge-${level.stage}-${level.level}`]"></i>
</template>

<style lang="less" scoped>
.k-badge-level {
    display: inline-block;
    vertical-align: middle;
    width: 1.76rem;
    height: .48rem;
    &.badge-4-1 {
        background: url("https://staticcdn-yy-prd.pydp888.com/g/img/user/1.0/lv-bar/4-1.png") center/100% 100% no-repeat;
    }
}
</style>

<script>
export default {
    name: 'k-badge-level',
    props: {
        level: Object
    }
}
</script>

